import React, { Component } from "react";
import "./style.css";
class IntelligentAdvanceMajorContent extends Component {
  render() {
    const { item } = this.props;
    return (
      <div className="intelligentDataColumn_box">
        <div className="intelligentDataColumn_school_box">
          <div style={{ height: 35, width: 10 }} className="fl"></div>
          <div className="fl">{item.school_code}</div>
          <div className="fl major_left_15">{item.school_name}</div>
          <div className="clear"></div>
        </div>
        <table className="intelligentDataColumn_major_table_box">
          <tbody>
            {item.intelligent_advance_majors.map((major, index) => {
              return (
                <tr key={index}>
                  <td
                    style={{
                      borderLeft: 0,
                      width: "47%",
                      textAlign: "left",
                      paddingLeft: 5,
                    }}
                  >
                    {major.major_name}
                  </td>
                  <td style={{ width: "10%" }}>{major.plan_num}</td>
                  <td style={{ width: "5%" }}>{major.school_year}</td>
                  <td style={{ width: "10%" }}>{major.average_score}</td>
                  <td style={{ width: "10%" }}>{major.min_score}</td>
                  <td style={{ borderRight: 0, width: "18%" }}>{major.rank}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default IntelligentAdvanceMajorContent;



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentAdvanceMajorModal/components/IntelligentAdvanceMajorContent/index.js